import { useState } from "react";
import "./FAQ.css";

const faqs = [
  {
    question: "Lorem Ipsum is simply dummy text of the printing?",
    answer:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
  },
  {
    question: "Lorem Ipsum is simply dummy text of the printing?",
    answer:
      "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
  },
  {
    question: "Lorem Ipsum is simply dummy text of the printing?",
    answer:
      "When an unknown printer took a galley of type and scrambled it.",
  },
  {
    question: "Lorem Ipsum is simply dummy text of the printing?",
    answer:
      "It has survived not only five centuries, but also the leap into electronic typesetting.",
  },
];

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className="faq-page">
      {/* HERO */}
      <section className="faq-hero">
        <div className="faq-hero-content">
          <h1>Frequently Asked Questions</h1>
          <p>
            Find answers about ordering, shipping, payments, and NX Optics
            products
          </p>
        </div>
      </section>

      {/* FAQ LIST */}
      <section className="faq-section">
        <div className="faq-container">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`faq-item ${
                activeIndex === index ? "active" : ""
              }`}
            >
              <button
                className="faq-question"
                onClick={() =>
                  setActiveIndex(activeIndex === index ? -1 : index)
                }
              >
                {faq.question}
                <span className="arrow">
                  {activeIndex === index ? "▲" : "▼"}
                </span>
              </button>

              {activeIndex === index && (
                <div className="faq-answer">{faq.answer}</div>
              )}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Faq;
